__turbopack_context__.v({
  "btn": "preview-module-scss-module__VIDj8W__btn",
  "buttonLeave": "preview-module-scss-module__VIDj8W__buttonLeave",
  "buttonRefresh": "preview-module-scss-module__VIDj8W__buttonRefresh",
  "footer": "preview-module-scss-module__VIDj8W__footer",
  "footerActions": "preview-module-scss-module__VIDj8W__footerActions",
  "refreshHint": "preview-module-scss-module__VIDj8W__refreshHint",
  "scrollArea": "preview-module-scss-module__VIDj8W__scrollArea",
  "section": "preview-module-scss-module__VIDj8W__section",
  "wrapper": "preview-module-scss-module__VIDj8W__wrapper",
});
